// @ts-ignore
import { AppSidebarToggler } from '@coreui/react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../../global';
export var ODHeader = function () {
    var _a = useGlobalContext(), _b = _a.state.def.logo, logoString = _b.logoString, _c = _b.textColor, textColor = _c === void 0 ? '{{primary}}' : _c, convertThemeString = _a.convertThemeString;
    var color = convertThemeString(textColor);
    return (React.createElement(React.Fragment, null,
        React.createElement(AppSidebarToggler, { className: "d-lg-none", display: "md", mobile: true }),
        React.createElement(Link, { to: '/', style: { textDecoration: 'none' } },
            React.createElement("span", { style: { fontSize: 24, fontWeight: 'bold', paddingLeft: 20, color: color } }, logoString))));
};
//# sourceMappingURL=ODHeader.js.map